import { Link } from "@/src/lib/next-compat";

type AccessErrorProps = {
    title: string;
    message: string;
    primaryHref: string;
    primaryLabel: string;
};

export function AccessError({ title, message, primaryHref, primaryLabel }: AccessErrorProps) {
    return (
        <div className="min-h-[70vh] flex items-center justify-center px-6 py-16">
            <div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                <h1 className="text-xl font-bold text-slate-900">{title}</h1>
                <p className="mt-2 text-sm text-slate-600">{message}</p>
                <div className="mt-6 flex items-center gap-3">
                    <Link
                        to={primaryHref}
                        className="inline-flex items-center justify-center rounded-lg bg-indigo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-700"
                    >
                        {primaryLabel}
                    </Link>
                </div>
            </div>
        </div>
    );
}

